require('./_common/css/grille_rwd.scss');
require('./_common/css/table_rwd.scss');
require('./public/css/index.scss');